(function () {
  function lockScroll() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    var scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function getPopup() {
    return document.querySelector('product-info #PBFPopup');
  }

  function getFinanceButton() {
    return document.querySelector('product-info #PBFPopup .pbf-finance-widget-button');
  }

  // Detect if widget exists on this product page
  function hasNovunaWidget() {
    // finance button is the most reliable signal in your code
    if (getFinanceButton()) return true;

    // fallback signals (in case button differs)
    if (document.querySelector('product-info #PBFPopup .pbf-finance-widget-calculator')) return true;
    if (document.querySelector('product-info #PBFPopup [class*="pbf-finance-widget"]')) return true;

    return false;
  }

  function hidePopupOnLoad() {
    var popup = getPopup();
    if (!popup) return;
    popup.style.display = 'none';
  }

  function ensurePopupEnhancements() {
    var popup = getPopup();
    if (!popup) return;

    if (!popup.querySelector('.PBFPopup--bg')) {
      popup.insertAdjacentHTML('beforeend', '<div class="PBFPopup--bg" data-novuna-close></div>');
    }

    var calc = popup.querySelector('.pbf-finance-widget-calculator');
    if (calc && !calc.querySelector('.PBFPopup--header')) {
      calc.insertAdjacentHTML(
        'afterbegin',
        '<div class="PBFPopup--header"><span>Finance options</span><svg data-novuna-close width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6875 18.6875L7.3125 7.3125M18.6875 7.3125L7.3125 18.6875" stroke="#030303" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
      );
    }
  }

  function openNovuna() {
    // hard gate: do nothing if widget not present
    if (!document.body.classList.contains('hasNovunaWidget')) return;

    ensurePopupEnhancements();

    var financeBtn = getFinanceButton();
    if (financeBtn) financeBtn.click();

    document.body.classList.add('FactoryNovuna', 'isNovuaOpen');
    lockScroll();
  }

  function closeNovuna() {
    if (!document.body.classList.contains('hasNovunaWidget')) return;

    var financeBtn = getFinanceButton();
    if (financeBtn) financeBtn.click();

    document.body.classList.remove('isNovuaOpen');

    var popup = getPopup();
    if (popup) popup.style.display = 'none';

    unlockScroll();
  }

  var bound = false;
  function bind() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-novuna-trigger]');
      if (trigger) {
        e.preventDefault();
        openNovuna();
        return;
      }

      var closer = e.target.closest('[data-novuna-close]');
      if (closer) {
        e.preventDefault();
        closeNovuna();
        return;
      }
    });
  }

  function markCTAsVisible() {
    document.body.classList.add('hasNovunaWidget');
  }

  function init() {
    document.body.classList.add('FactoryNovuna');
    hidePopupOnLoad();

    // If widget is already there, enable immediately
    if (hasNovunaWidget()) {
      markCTAsVisible();
      return;
    }

    // If widget injects late, poll a few times then stop
    var tries = 0;
    var maxTries = 20; // ~10s at 500ms
    var timer = setInterval(function () {
      tries++;
      hidePopupOnLoad();

      if (hasNovunaWidget()) {
        markCTAsVisible();
        clearInterval(timer);
      }

      if (tries >= maxTries) clearInterval(timer);
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    bind();
  });

  document.addEventListener('shopify:section:load', function () {
    init();
    bind();
  });
})();
